import { MarketingPreferenceChoice } from '../utils/marketing-preferences';

/**
 * Consent copy changes are tracked in Git. Before making a material change, review
 * whether existing consent remains valid and whether tenants who have already
 * opted in need to be informed.
 */
export const MARKETING_CONSENT_STATEMENT = {
  heading: 'Want to hear from us?',
  text: "I'd like Reposit to send me news and offers about Reposit products and services, as well as relevant products and offers from its partners, by:",
  footnote: 'You can change your preferences or opt out at any time.',
};

export const MARKETING_CONSENT_CHANNELS: ReadonlyArray<{
  key: keyof MarketingPreferenceChoice;
  label: string;
}> = [
  { key: 'emailOptIn', label: 'Email' },
  { key: 'smsOptIn', label: 'SMS/WhatsApp' },
];